import {
  SET_USER_SETTINGS,
  RECEIVE_USER_SETTINGS,
  SET_POPINFO_ID,
} from '../actions'

const initialState = {
  trainPositionAutoRefresh: false,
  popinfoId: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_SETTINGS:
      return {
        ...state,
        trainPositionAutoRefresh: action.payload.train_position_auto_refresh,
      }
    case RECEIVE_USER_SETTINGS:
      return {
        ...state,
        trainPositionAutoRefresh: action.payload.user.train_position_auto_refresh
      }
    case SET_POPINFO_ID:
      return {
        ...state,
        popinfoId: action.popinfoId,
      }
    default:
      return state
  }
}

export default reducer
